<header class="faq-page">
    <div class="container">
        <div class="row">
            <div class="col-md-6 col-xs-6">
                <img class="Logo-160x64" src="assets/images/logo-160-x-64.svg" style="margin-bottom: 20px;" alt="Logo San Cristobal">
            </div>
            <div class="col-md-6 col-xs-6 mobile-hidden">
                <p class="number-phone">0810 8888 727</p>
            </div>
        </div>
        <div class="row">
            <div class="col-md-8 col-md-offset-2 col-xs-12 text-center">
                <h1>¿Necesitas ayuda?</h1>
            </div>
        </div>
        <div class="row">
            <div class="col-md-8 col-md-offset-2 col-xs-12 text-center">
                <p class="subtitle mobile-hidden">Te acercamos un listado con preguntas frecuentes<br>
                    para ayudarte a resolver tus inquietudes.</p>
                <p class="subtitle desktop-hidden">Te acercamos un listado con preguntas <br> frecuentes
                    para ayudarte a resolver tus<br> inquietudes.</p>
            </div>
        </div>
        <div class="desktop-hidden row padding-center-help">
            <div class="col-md-8 col-md-offset-2 col-xs-12 center-hep">
                <p class="text-center">Nueva línea de Soporte PAS</p><br>
                <a class="text-center" href="tel:0810 8888 727">0810 8888 727</a>
            </div>
        </div>
    </div>
    
</header>
<section>
    <div class="row container">
        <div class="col-md-8 col-md-offset-2">
            <sc-accordion-group>
                    <div class="accordion-division" *ngFor="let question of questions">
                        <sc-accordion [questionId]="question.id" [title]="question.pregunta" id="pregunta_{{question.id}}">
                            {{ question.respuesta }}
                        </sc-accordion>
                    </div>
            </sc-accordion-group>
        </div>
    </div>
</section>
<footer>
    <div class="container">
        <div class="row">
            <div class="col-md-6 col-xs-12">
                <h2>¿Aún te quedan dudas?</h2>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 col-xs-12">
                <p class="footer-subtitle mobile-hidden">Comunicate con nuestro equipo de soporte llamando<br>al <span class="footer-phone">0810 8888 727</span> de Lunes a Viernes de 8 a 20 HS.<br>
                        o escribinos a <a id="ayuda_mail" class="mailTo" href="mailto:soportepas@sancristobal.com.ar">soportepas@sancristobal.com.ar</a></p>
                        <p class="footer-subtitle desktop-hidden">Comunicate con nuestro equipo de<br> soporte llamando al <span class="footer-phone">0810 8888 727</span><br> de Lunes a Viernes de 8 a 20 HS.<br>
                            o escribinos a <a id="ayuda_mail" class="mailTo" href="mailto:soportepas@sancristobal.com.ar">soportepas@sancristobal.com.ar</a></p>        
            </div>
        </div>
    </div>
    
</footer>
